import React, { createContext, useContext, useState } from 'react';

import {
  CardId,
  TCard,
} from '@/console/features/card-layout/card-layout.types';
import { initialCards } from '@/console/features/card-layout/context/card-layout-context.constants';
import { recalculatePositions } from '@/console/features/card-layout/utils/position-finder';

import {
  TCardLayoutContext,
  TCardLayoutProvider,
} from './card-layout-context.types';

const CardLayoutContext = createContext<TCardLayoutContext | undefined>(
  undefined,
);

export const useCardLayout = () => {
  const context = useContext(CardLayoutContext);
  if (!context) {
    throw new Error('useCardLayout must be used within CardLayoutProvider');
  }
  return context;
};

export const CardLayoutProvider = ({ children }: TCardLayoutProvider) => {
  const [cards, setCards] = useState<TCard[]>(initialCards);

  const removeCard = (cardId: CardId) => {
    const newCards = cards.filter((card) => card.id !== cardId);
    setCards(recalculatePositions(newCards));
  };

  return (
    <CardLayoutContext
      value={{
        cards,
        setCards,
        removeCard,
      }}
    >
      {children}
    </CardLayoutContext>
  );
};
